import {
  LayoutDashboard,
  CreditCard,
  Settings as SettingsIcon,
  RefreshCcw,
  Boxes,
  Package,
  ShoppingBag,
  UserCircle2,
  Newspaper,
  MessageSquareQuote,
  Image as ImageIcon,
  Sliders,
  Phone,
  Search,
  Home as HomeIcon,
  Menu as MenuIcon,
  UsersRound,
  ScrollText,
  ListTree,
  Award,
  Users as UsersAdminIcon,
  Database,
  type LucideIcon,
} from "lucide-react"

/**
 * Lookup table that converts a string identifier into the actual Lucide
 * icon component. Required because the parent Nav lives in a server
 * component (it receives Payload's `ServerProps`) but the child
 * NavSection is `"use client"` for the collapse state — and React
 * Server Component serialization refuses to pass function references
 * (Lucide icons are functions) across the boundary. Strings serialize
 * fine; the client component looks the icon up here at render time.
 *
 * Keep this map in sync with the keys used in `index.tsx`'s GROUPS
 * configuration. TypeScript will surface unknown names at compile time
 * via the `IconName` union below.
 */
export const ICONS = {
  dashboard: LayoutDashboard,
  payments: CreditCard,
  settings: SettingsIcon,
  refresh: RefreshCcw,
  boxes: Boxes,
  package: Package,
  shoppingBag: ShoppingBag,
  userCircle: UserCircle2,
  newspaper: Newspaper,
  testimonial: MessageSquareQuote,
  image: ImageIcon,
  sliders: Sliders,
  phone: Phone,
  search: Search,
  home: HomeIcon,
  menu: MenuIcon,
  team: UsersRound,
  scroll: ScrollText,
  listTree: ListTree,
  award: Award,
  usersAdmin: UsersAdminIcon,
  database: Database,
} as const satisfies Record<string, LucideIcon>

export type IconName = keyof typeof ICONS
